import { MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { NAV_ITEMS, WHATSAPP_DISPLAY, WHATSAPP_URL } from "@/content/site";

interface FooterProps {
  /** Esconde a navegação por âncoras (usado fora da página inicial). */
  showNav?: boolean;
}

const Footer = ({ showNav = true }: FooterProps) => (
  <footer className="bg-paper">
    <div className="mx-auto max-w-page px-5 pt-12 sm:px-8 sm:pt-16">
      <div className="grid gap-10 pb-10 sm:gap-12 sm:pb-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo />
          <p className="mt-5 max-w-[360px] text-[15px] leading-relaxed text-ink-600">
            Software, IA e automação sob medida para empresas que querem crescer com tecnologia.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-whatsapp/10 px-4 py-2.5 text-[14px] font-medium text-whatsapp-dark ring-1 ring-whatsapp/30 transition hover:bg-whatsapp/15"
          >
            <MessageCircle className="h-4 w-4" aria-hidden="true" />
            {WHATSAPP_DISPLAY}
          </a>
        </div>

        {showNav && (
          <nav aria-label="Rodapé" className="grid grid-cols-2 gap-8 lg:col-span-7 lg:grid-cols-3">
            <div>
              <p className="font-mono text-[11.5px] uppercase tracking-[0.16em] text-ink-500">Navegação</p>
              <ul className="mt-5 space-y-3 text-[15px] text-ink-700">
                {NAV_ITEMS.map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="transition-colors hover:text-brand-700">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11.5px] uppercase tracking-[0.16em] text-ink-500">Contato</p>
              <ul className="mt-5 space-y-3 text-[15px] text-ink-700">
                <li>
                  <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-brand-700">
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        )}
      </div>

      <div className="border-t border-ink-900/[0.08] py-7 text-[13px] text-ink-500">
        <p>© {new Date().getFullYear()} Vexly AI Solutions. Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
